import {useTranslation} from "react-i18next";
import UrlsConfig from "@/config/UrlsConfig";
import BreadcrumbsInlab, {BreadcrumbLink} from "@/components/BreadcrumbsInlab/BreadcrumbsInlab";
import {Helmet} from "react-helmet";
import {titleSuffix} from "@/config/Other";
import Page from "@/features/Page/Page";
import PageHeading from "@/features/PageHeading/PageHeading";
import FileMeaningsContent
    from "@/features/InControlPanel/ReferenceBooks/LaboratoryClarifications/FileMeanings/FileMeaningsContent";
import {WithPermission} from "@/components/Permissions/WithPermission";
import Page404 from "@/pages/Error/404/Page404";

function ReferenceBookFileMeanings() {
    const {t} = useTranslation();

    const urlsConfig = new UrlsConfig();
    const title = t("File meanings");

    const breadLinks: BreadcrumbLink[] = [
        {
            title: t("Index"),
            to: urlsConfig.index.to
        },
        {
            title: t("Reference books"),
            to: urlsConfig.referenceBooks.to,
        },
        {
            title: t("Lists"),
            to: urlsConfig.referenceBooksLists.to,
        },
        {
            title,
            to: urlsConfig.referenceBookFileMeanings.to,
        },
    ];

    return (
      <WithPermission permission="file-meanings.show" fallback={<Page404/>}>
          <Helmet>
              <title>{title}{titleSuffix}</title>
          </Helmet>

          <BreadcrumbsInlab links={breadLinks} showBackBtn/>
          <Page>
              <PageHeading>{title}</PageHeading>

              <FileMeaningsContent/>
          </Page>
      </WithPermission>
    )
}

export default ReferenceBookFileMeanings;
